import { ITechnician } from '../../../../../app/entities/Technician'
import { IWeekCalendarPartial } from '../../../../../app/entities/WeekCalendar'

export function getTechById(technicianObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/byObjectId/${technicianObjectId}`,
  }
}
export const getLocationByLocationId = (locationObjectId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationObjectId}`,
  }
}
export const getPicturesByIds = (technicianIds: string[]) => {
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/technicians/pictures?techObjectIds=${JSON.stringify(technicianIds)}`,
  }
}
export const editTech = (body: any) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians`,
    body,
  }
}
export function editTechnicianWeekCalendar(
  body: IWeekCalendarPartial,
  technicianId: string | undefined,
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/week-calendar`,
    body,
  }
}
export function createTechnicianWeekCalendars(
  body: IWeekCalendarPartial[],
  technicianId: string | undefined,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/week-calendar`,
    body,
  }
}

export function createTech(body: any) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians`,
    body,
  }
}
export function initializeTechnicianSchedule(technicianId: string) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/initialize-schedule`,
  }
}
export const createDaySetting = (
  body: any,
  technicianId: string | undefined,
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/day-settings`,
    body,
  }
}
export const updateDaySetting = (
  body: any,
  technicianId: string | undefined,
) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/day-settings`,
    body,
  }
}
export const deleteDaySetting = (
  technicianId: string | undefined,
  daySettingId: string,
) => {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianId}/day-settings/${daySettingId}`,
  }
}
export const setTechToLocation = (
  locationId: string | null,
  technicianId: string,
) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/technicians/${technicianId}`,
  }
}

export function uploadTechAvatar(technicianObjectId: string, image: FormData) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/avatar`,
    body: image,
  }
}

export function determineEffectOfTechnicianUpdate(
  technicianObjectId: string,
  bumpToPendingRescheduling: boolean,
  newTechnicianMode?: Pick<
    ITechnician,
    'inactive' | 'acceptsDeliveries' | 'acceptsInstallations'
  >,
  newLocationObjectId?: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/${technicianObjectId}/update/check`,
    body: {
      bumpToPendingRescheduling,
      newTechnicianMode,
      newLocationObjectId,
    },
  }
}
